import { Field } from "src/search/types";
import { attributeToTitle } from "src/utils/strings";
import { AggregationConfig } from "../types";
import { memo, ReactNode } from "react";
import styles from "../table/Table.module.css";
import { TooltipContext } from "./tooltip-types";
import { resolveTooltip } from "./registry";
import { TableFormatter } from "../utils/table-utils";

interface TooltipProps {
  field: Field;
  title: string;
  type?: "default" | "aggregation" | "formula" | "entity" | "dimension";
  aggregation?: AggregationConfig;
  formula?: string;
  unit?: string;
}

export function TableColumnHeaderTooltip(props: TooltipProps) {
  const { field, title, type = "default", aggregation, formula, unit } = props;
  const displayTitle = TableFormatter.formatDimension(title, field.attribute);

  //want to provide more context.  For example,
  //if this is a week we want to provide the full data for that week.

  const defaultContent = <span>{displayTitle}</span>;

  const tooltipContext: TooltipContext = {
    type:
      type === "default"
        ? "dimension"
        : type === "aggregation"
        ? "measure"
        : "formula",
    field,
    value: title,
    formattedValue: displayTitle,
    metadata: {
      aggregation,
      formula,
      unit,
    },
    children: defaultContent,
  };

  // Ensure we always return a React element
  const tooltipContent = resolveTooltip(tooltipContext);
  return tooltipContent ? <>{tooltipContent}</> : defaultContent;
}

interface VZBLTooltipProps {
  type?:
    | "measure"
    | "comparison"
    | "entity"
    | "dimension"
    | "formula"
    | "group"
    | "measure-group";
  value: any;
  formattedValue: string | ReactNode;
  field?: Field;
  record?: any;
  metadata?: any;
  aggregations?: any[];
  formulas?: any[];
  columnInfo?: any;
  config?: any;
  children?: ReactNode;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  currentColumn?: any;
  groupBys?: Field[];
  pivotGroups?: Field[];
}

const VZBLTooltipComponent = (props: VZBLTooltipProps) => {
  const cellContent = (
    <div
      className={props.type === "measure" ? styles.numericCell : styles.cell}
      onClick={props.onClick}
    >
      {props.children}
    </div>
  );

  const tooltipContext: TooltipContext = {
    type: props.type || "measure",
    value: props.value,
    formattedValue: props.formattedValue,
    field: props.field,
    record: props.record,
    metadata: props.metadata,
    aggregations: props.aggregations,
    formulas: props.formulas,
    columnInfo: props.columnInfo,
    config: props.config,
    currentColumn: props.currentColumn,
    groupBys: props.groupBys,
    pivotGroups: props.pivotGroups,
    children: cellContent,
  };

  // Ensure we always return a React element
  const tooltipContent = resolveTooltip(tooltipContext);
  return tooltipContent ? <>{tooltipContent}</> : cellContent;
};

export const VZBLTooltip = memo(VZBLTooltipComponent);
